import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { type OpenableControls } from '../../../../generic-hooks'

import { ProductPageNowDialogDynamicContent } from './ProductPageNowDialogDynamicContent'

export type ProductPageNowDeliveryDetailsDialogOpenableControls = Pick<
  OpenableControls,
  'handleClose' | 'isOpen'
>

export const ProductPageNowDeliveryDetailsDialog: FC<{
  controls: ProductPageNowDeliveryDetailsDialogOpenableControls
}> = ({ controls }) => {
  return (
    <Dialog
      onClose={controls.handleClose}
      open={controls.isOpen}
      slotProps={{
        dialog: { className: 'w-auto' },
      }}
    >
      <DialogTitle onClose={controls.handleClose}>
        <FormattedMessage id="now.deliveryDetailsModal.title" />
      </DialogTitle>
      <DialogContent className="h-full w-auto bg-light-primary-medium p-5">
        <ProductPageNowDialogDynamicContent />
      </DialogContent>
    </Dialog>
  )
}
